import { UnitRegistry } from '.';

export function ftInToCm(ft: number, inches: number): number {
  const ftConfig = UnitRegistry.ft;
  const inConfig = UnitRegistry.in;

  const ftToMFactor = 1 / ftConfig.baseFactor;
  const inToMFactor = 1 / inConfig.baseFactor;

  const ftInM = ft * ftToMFactor;
  const inInM = inches * inToMFactor;

  const ftInCm = ftInM * 100;
  const inchesInCm = inInM * 100;

  return ftInCm + inchesInCm;
}

export function lbsToKg(lbs: number): number {
  const lbsConfig = UnitRegistry.lbs;

  const lbsToKgFactor = 1 / lbsConfig.baseFactor;

  const lbsInKg = lbs * lbsToKgFactor;

  return lbsInKg;
}

/**
 * Converts centimeters to feet and inches.
 */
export function cmToFtIn(cm: number): { ft: number; in: number } {
  const inConfig = UnitRegistry.in;
  const cmConfig = UnitRegistry.cm;

  const baseUnit = cm / cmConfig.baseFactor; // m is the base unit

  const totalInches = baseUnit * inConfig.baseFactor;

  const ft = Math.floor(totalInches / 12);
  const in_ = Math.round(totalInches % 12);

  // Rounding the remainder up can yield 12 inches (e.g. 11.6 → 12). Carry it into the feet so the
  // returned inches stay in the 0–11 range.
  if (in_ === 12) {
    return { ft: ft + 1, in: 0 };
  }

  return { ft, in: in_ };
}

/**
 * Converts kilograms to pounds.
 */
export function kgToLbs(kg: number): number {
  const lbsConfig = UnitRegistry.lbs;

  const baseUnit = kg; // kg is the base unit

  return baseUnit * lbsConfig.baseFactor;
}
